<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      Eleven Cashless
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-row>
        <v-col cols="12">
          <BaseTextField
            label="URL Eleven Cashless"
            :placeholder="$t('events.event-config.insert-cashless-url')"
            v-model="$produtos_gerenciar.cadastro.cashless.url_cashless_prod"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import BaseTextField from "@/components/forms/BaseTextField.vue";
export default {
  name: "AccessRules",
  components: {
    BaseTextField,
  },
  data: () => ({}),
  computed: {},
};
</script>

<style scoped></style>
